import { HotspotIcon, HotspotSettings } from '@lessonup/pins-shared';
import {
  IconAdd,
  IconApps,
  IconArchive,
  IconArrowBendDownRight,
  IconArrowDown,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconBadge,
  IconBook,
  IconBrain,
  IconBrush,
  IconBrushBig,
  IconCalendar,
  IconCamera,
  IconCart,
  IconCheck,
  IconCheckbox,
  IconCheckboxChecked,
  IconCheckFill,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconClassroom,
  IconClip,
  IconClose,
  IconCloudDownload,
  IconCloudUpload,
  IconCloudUploadAdd,
  IconCloudUploadDone,
  IconCogwheel,
  IconColor,
  IconColumns,
  IconComponentAudio,
  IconComponentFormula,
  IconComponentImage,
  IconComponentTraffic,
  IconComponentVideo,
  IconCookie,
  IconCopy,
  IconCroissant,
  IconCut,
  IconDesktop,
  IconDice,
  IconDifferentiation,
  IconDownload,
  IconDrop,
  IconEdit,
  IconEmail,
  IconEmojiLaugh,
  IconEnlarge,
  IconEraser,
  IconEuro,
  IconFeedback,
  IconFile,
  IconFileText,
  IconFlag,
  IconFlowChartActionFill,
  IconFolder,
  IconGraduationCap,
  IconHeadphones,
  IconHeart,
  IconHelp,
  IconHistory,
  IconHome,
  IconImageStack,
  IconInbox,
  IconInfinity,
  IconInfo,
  IconJoystick,
  IconKeyboard,
  IconLanguage,
  IconLaptop,
  IconLesson,
  IconLessonPlan,
  IconLinkAdd,
  IconLockClosed,
  IconLockOpen,
  IconLuggage,
  IconMagnifyingGlass,
  IconMap,
  IconMegaphone,
  IconMicrophone,
  IconMinus,
  IconMultiply,
  IconNote,
  IconNotificationOn,
  IconOpenInNew,
  IconPageAccount,
  IconClipboard,
  IconPageLibrary,
  IconParagraph,
  IconPaste,
  IconPayment,
  IconPencil,
  IconPension,
  IconPeople,
  IconPerson,
  IconPhone,
  IconPin,
  IconPlanet,
  IconPlant,
  IconPlay,
  IconPlus,
  IconPower,
  IconPowerpoint,
  IconPresent,
  IconPresenter,
  IconPrint,
  IconPrivacy,
  IconRadioButton,
  IconRadioTower,
  IconRefresh,
  IconRemove,
  IconReport,
  IconReset,
  IconRobot,
  IconRocket,
  IconRuler,
  IconSchool,
  IconSearch,
  IconSend,
  IconShareAlt,
  IconShoppingBag,
  IconShrink,
  IconSlideTypePoll,
  IconStack,
  IconStar,
  IconStarFill,
  IconStopFill,
  IconStudent,
  IconStudentQuestion,
  IconSun,
  IconSupport,
  IconTeachingSessions,
  IconTime,
  IconTransport,
  IconTrophy,
  IconUnmarked,
  IconUpload,
  IconVisibilityOff,
  IconVisibilityOn,
  IconVoucher,
  IconWand,
  IconWarning,
  IconWrench,
  IconZoomIn,
  IconZoomOut,
} from '@lessonup/ui-components';
import React from 'react';

type HotspotIconType = {
  icon: React.JSX.Element;
  translateKey: string;
};

type HotspotIconRecordEntry = {
  icon: (props: React.SVGProps<SVGSVGElement>) => React.JSX.Element;
  translateKey: string;
};

export const hotspotIconMapper: Record<HotspotIcon, HotspotIconRecordEntry> = {
  ACCOUNT: { icon: IconPageAccount, translateKey: 'iconPageAccount' },
  ACTIVITY: { icon: IconBrain, translateKey: 'iconBrain' },
  ADD: { icon: IconAdd, translateKey: 'iconAdd' },
  APPS: { icon: IconApps, translateKey: 'iconApps' },
  ARCHIVE: { icon: IconArchive, translateKey: 'iconArchive' },
  ARROW_BACK: { icon: IconArrowLeft, translateKey: 'iconArrowLeft' },
  ARROW_BEND_DOWN_RIGHT: { icon: IconArrowBendDownRight, translateKey: 'iconArrowBendDownRight' },
  ARROW_DOWN: { icon: IconArrowDown, translateKey: 'iconArrowDown' },
  ARROW_FORWARD: { icon: IconArrowRight, translateKey: 'iconArrowRight' },
  ARROW_UP: { icon: IconArrowUp, translateKey: 'iconArrowUp' },
  AUDIO: { icon: IconComponentAudio, translateKey: 'iconComponentAudio' },
  BADGE: { icon: IconBadge, translateKey: 'iconBadge' },
  BOOK: { icon: IconBook, translateKey: 'iconBook' },
  BRUSH: { icon: IconBrush, translateKey: 'iconBrush' },
  BRUSH_BIG: { icon: IconBrushBig, translateKey: 'iconBrushBig' },
  CALENDAR: { icon: IconCalendar, translateKey: 'iconCalendar' },
  CAMERA: { icon: IconCamera, translateKey: 'iconCamera' },
  CART: { icon: IconCart, translateKey: 'iconCart' },
  CHECK: { icon: IconCheck, translateKey: 'iconCheck' },
  CHECK_FILL: { icon: IconCheckFill, translateKey: 'iconCheckFill' },
  CHECKBOX: { icon: IconCheckbox, translateKey: 'iconCheckbox' },
  CHECKBOX_CHECKED: { icon: IconCheckboxChecked, translateKey: 'iconCheckboxChecked' },
  CHEVRON_DOWN: { icon: IconChevronDown, translateKey: 'iconChevronDown' },
  CHEVRON_LEFT: { icon: IconChevronLeft, translateKey: 'iconChevronLeft' },
  CHEVRON_RIGHT: { icon: IconChevronRight, translateKey: 'iconChevronRight' },
  CHEVRON_UP: { icon: IconChevronUp, translateKey: 'iconChevronUp' },
  CLASSROOM: { icon: IconClassroom, translateKey: 'iconClassroom' },
  CLIP: { icon: IconClip, translateKey: 'iconClip' },
  CLOSE: { icon: IconClose, translateKey: 'iconClose' },
  CLOUD: { icon: IconCloudUpload, translateKey: 'iconCloudUpload' },
  CLOUD_DOWNLOAD: { icon: IconCloudDownload, translateKey: 'iconCloudDownload' },
  CLOUD_UPLOAD_ADD: { icon: IconCloudUploadAdd, translateKey: 'iconCloudUploadAdd' },
  CLOUD_UPLOAD_DONE: { icon: IconCloudUploadDone, translateKey: 'iconCloudUploadDone' },
  COINS: { icon: IconTeachingSessions, translateKey: 'iconTeachingSessions' },
  COLOR: { icon: IconColor, translateKey: 'iconColor' },
  COLUMNS: { icon: IconColumns, translateKey: 'iconColumns' },
  COGWHEEL: { icon: IconCogwheel, translateKey: 'iconCogwheel' },
  COMPONENT_FORMULA: { icon: IconComponentFormula, translateKey: 'iconComponentFormula' },
  COOKIE: { icon: IconCookie, translateKey: 'iconCookie' },
  COPY: { icon: IconCopy, translateKey: 'iconCopy' },
  CUT: { icon: IconCut, translateKey: 'iconCut' },
  DELETE: { icon: IconRemove, translateKey: 'iconRemove' },
  DESKTOP: { icon: IconDesktop, translateKey: 'iconDesktop' },
  DICE: { icon: IconDice, translateKey: 'iconDice' },
  DIFFERENTIATION: { icon: IconDifferentiation, translateKey: 'iconDifferentiation' },
  DOWNLOAD: { icon: IconDownload, translateKey: 'iconDownload' },
  DROP: { icon: IconDrop, translateKey: 'iconDrop' },
  EDIT: { icon: IconEdit, translateKey: 'iconEdit' },
  EMAIL: { icon: IconEmail, translateKey: 'iconEmail' },
  EMOJI_LAUGH: { icon: IconEmojiLaugh, translateKey: 'iconEmojiLaugh' },
  ENLARGE: { icon: IconEnlarge, translateKey: 'iconEnlarge' },
  ERASER: { icon: IconEraser, translateKey: 'iconEraser' },
  EURO: { icon: IconEuro, translateKey: 'iconEuro' },
  EYE: { icon: IconVisibilityOn, translateKey: 'iconVisibilityOn' },
  FEEDBACK: { icon: IconFeedback, translateKey: 'iconFeedback' },
  FILE: { icon: IconFile, translateKey: 'iconFile' },
  FILE_TEXT: { icon: IconFileText, translateKey: 'iconFileText' },
  FLAG: { icon: IconFlag, translateKey: 'iconFlag' },
  FLOW_CHART_ACTION_FILL: { icon: IconFlowChartActionFill, translateKey: 'iconFlowChartActionFill' },
  FOLDER: { icon: IconFolder, translateKey: 'iconFolder' },
  HAND_RAISED: { icon: IconStudentQuestion, translateKey: 'iconStudentQuestion' },
  HEADPHONES: { icon: IconHeadphones, translateKey: 'iconHeadphones' },
  HEART_OUTLINE: { icon: IconHeart, translateKey: 'iconHeart' },
  HELP: { icon: IconHelp, translateKey: 'iconHelp' },
  HISTORY: { icon: IconHistory, translateKey: 'iconHistory' },
  HOME: { icon: IconHome, translateKey: 'iconHome' },
  IMAGE: { icon: IconComponentImage, translateKey: 'iconComponentImage' },
  IMAGE_STACK: { icon: IconImageStack, translateKey: 'iconImageStack' },
  INBOX: { icon: IconInbox, translateKey: 'iconInbox' },
  INFINITY: { icon: IconInfinity, translateKey: 'iconInfinity' },
  INFO: { icon: IconInfo, translateKey: 'iconInfo' },
  JOYSTICK: { icon: IconJoystick, translateKey: 'iconJoystick' },
  KEYBOARD: { icon: IconKeyboard, translateKey: 'iconKeyboard' },
  LANGUAGE: { icon: IconLanguage, translateKey: 'iconLanguage' },
  LAPTOP: { icon: IconLaptop, translateKey: 'iconLaptop' },
  LESSON: { icon: IconLesson, translateKey: 'iconLesson' },
  LESSON_PLAN: { icon: IconLessonPlan, translateKey: 'iconLessonPlan' },
  LINK: { icon: IconLinkAdd, translateKey: 'iconLinkAdd' },
  LOCK: { icon: IconLockClosed, translateKey: 'iconLockClosed' },
  LOCK_OPEN: { icon: IconLockOpen, translateKey: 'iconLockOpen' },
  LUGGAGE: { icon: IconLuggage, translateKey: 'iconLuggage' },
  LUNCH: { icon: IconCroissant, translateKey: 'iconCroissant' },
  MAP: { icon: IconMap, translateKey: 'iconMap' },
  MEDIA_LIBRARY: { icon: IconPageLibrary, translateKey: 'iconPageLibrary' },
  MEGAPHONE: { icon: IconMegaphone, translateKey: 'iconMegaphone' },
  MAGNIFYING_GLASS: { icon: IconMagnifyingGlass, translateKey: 'iconMagnifyingGlass' },
  MICROPHONE: { icon: IconMicrophone, translateKey: 'iconMicrophone' },
  MINUS: { icon: IconMinus, translateKey: 'iconMinus' },
  MULTIPLY: { icon: IconMultiply, translateKey: 'iconMultiply' },
  NOTE: { icon: IconNote, translateKey: 'iconNote' },
  NOTIFICATIONS: { icon: IconNotificationOn, translateKey: 'iconNotificationOn' },
  OPEN_IN_NEW: { icon: IconOpenInNew, translateKey: 'iconOpenInNew' },
  PARAGRAPH: { icon: IconParagraph, translateKey: 'iconParagraph' },
  PASTE: { icon: IconPaste, translateKey: 'iconPaste' },
  PAYMENT: { icon: IconPayment, translateKey: 'iconPayment' },
  PENCIL: { icon: IconPencil, translateKey: 'iconPencil' },
  PENSION: { icon: IconPension, translateKey: 'iconPension' },
  PEOPLE: { icon: IconPeople, translateKey: 'iconPeople' },
  PERSON: { icon: IconPerson, translateKey: 'iconPerson' },
  PHONE: { icon: IconPhone, translateKey: 'iconPhone' },
  PLANET: { icon: IconPlanet, translateKey: 'iconPlanet' },
  PLANT: { icon: IconPlant, translateKey: 'iconPlant' },
  PLAY: { icon: IconPlay, translateKey: 'iconPlay' },
  PLUS: { icon: IconPlus, translateKey: 'iconPlus' },
  PIN: { icon: IconPin, translateKey: 'iconPin' },
  POWER: { icon: IconPower, translateKey: 'iconPower' },
  POWERPOINT: { icon: IconPowerpoint, translateKey: 'iconPowerpoint' },
  PRESENT: { icon: IconPresent, translateKey: 'iconPresent' },
  PRESENTER: { icon: IconPresenter, translateKey: 'iconPresenter' },
  PRINT: { icon: IconPrint, translateKey: 'iconPrint' },
  PRIVACY: { icon: IconPrivacy, translateKey: 'iconPrivacy' },
  QUESTION: { icon: IconUnmarked, translateKey: 'iconUnmarked' },
  RADIO_BUTTON: { icon: IconRadioButton, translateKey: 'iconRadioButton' },
  RADIO_TOWER: { icon: IconRadioTower, translateKey: 'iconRadioTower' },
  REPORT: { icon: IconReport, translateKey: 'iconReport' },
  REFRESH: { icon: IconRefresh, translateKey: 'iconRefresh' },
  RESET: { icon: IconReset, translateKey: 'iconReset' },
  ROBOT: { icon: IconRobot, translateKey: 'iconRobot' },
  ROCKET: { icon: IconRocket, translateKey: 'iconRocket' },
  RULER: { icon: IconRuler, translateKey: 'iconRuler' },
  SCHOOL: { icon: IconSchool, translateKey: 'iconSchool' },
  SEARCH: { icon: IconSearch, translateKey: 'iconSearch' },
  SEND: { icon: IconSend, translateKey: 'iconSend' },
  SHARE_ALT: { icon: IconShareAlt, translateKey: 'iconShareAlt' },
  SHRINK: { icon: IconShrink, translateKey: 'iconShrink' },
  SHOPPING_BAG: { icon: IconShoppingBag, translateKey: 'iconShoppingBag' },
  SLIDE_TYPE_POLL: { icon: IconSlideTypePoll, translateKey: 'iconSlideTypePoll' },
  STACK: { icon: IconStack, translateKey: 'iconStack' },
  STAR_OUTLINE: { icon: IconStar, translateKey: 'iconStar' },
  STAR_FILL: { icon: IconStarFill, translateKey: 'iconStarFill' },
  STOP_FILL: { icon: IconStopFill, translateKey: 'iconStopFill' },
  STUDENT: { icon: IconStudent, translateKey: 'iconStudent' },
  STUDENT_HAT: { icon: IconGraduationCap, translateKey: 'iconGraduationCap' },
  SUN: { icon: IconSun, translateKey: 'iconSun' },
  SUPPORT: { icon: IconSupport, translateKey: 'iconSupport' },
  TEST: { icon: IconClipboard, translateKey: 'iconClipboard' },
  TIME: { icon: IconTime, translateKey: 'iconTime' },
  TRAFFIC: { icon: IconComponentTraffic, translateKey: 'iconComponentTraffic' },
  TRANSPORT: { icon: IconTransport, translateKey: 'iconTransport' },
  TROPHY: { icon: IconTrophy, translateKey: 'iconTrophy' },
  UPLOAD: { icon: IconUpload, translateKey: 'iconUpload' },
  VIDEO: { icon: IconComponentVideo, translateKey: 'iconComponentVideo' },
  VISIBILITY_OFF: { icon: IconVisibilityOff, translateKey: 'iconVisibilityOff' },
  VOUCHER: { icon: IconVoucher, translateKey: 'iconVoucher' },
  WAND: { icon: IconWand, translateKey: 'iconWand' },
  WARNING: { icon: IconWarning, translateKey: 'iconWarning' },
  WRENCH: { icon: IconWrench, translateKey: 'iconWrench' },
  ZOOM_IN: { icon: IconZoomIn, translateKey: 'iconZoomIn' },
  ZOOM_OUT: { icon: IconZoomOut, translateKey: 'iconZoomOut' },
};

export const hotspotIconList = Object.keys(hotspotIconMapper) as HotspotIcon[];

export const transformHotspotIconRecordEntryToType = (t: HotspotIconRecordEntry): HotspotIconType => {
  return { icon: <t.icon />, translateKey: t.translateKey };
};

export const getHotspotIcon = (iconName: HotspotSettings['iconFill']): HotspotIconType => {
  return transformHotspotIconRecordEntryToType(hotspotIconMapper[iconName] || hotspotIconMapper.ROCKET);
};
